export const useSelectionProperties = (
  Host: HTMLElement,
  inputElement: () => HTMLInputElement | undefined,
): void => {
  Object.defineProperties(Host, {
    selectionStart: {
      get: () => inputElement()?.selectionStart || 0,
      set(newValue) {
        const i = inputElement();
        if (i) i.selectionStart = newValue;
      },
    },
    selectionEnd: {
      get: () => inputElement()?.selectionEnd || 0,
      set(newValue) {
        const i = inputElement();
        if (i) i.selectionEnd = newValue;
      },
    },
  });
};
